import { AllocationScenarioDetailSecurityModel, AllocationScenarioValuationModel } from 'api';
import { PresentValue } from './calculateAveragePricePerSecurity.types';

const calculateAveragePricePerSecurity = (
  securities: AllocationScenarioDetailSecurityModel[],
  allocationScenarios: AllocationScenarioValuationModel[]
) => {
  const securitiesAverage: { [key: number]: number } = {};
  securities.forEach(security => {
    let averagePrice = 0;
    const securityId = security.id as number;
    allocationScenarios.forEach(scenario => {
      const weighting = Number(scenario.weighting_probability);
      const presentValues = scenario.scenario_values?.present_values ?? [];
      presentValues.forEach((pv: PresentValue) => {
        if (pv.security.id === securityId) {
          averagePrice += pv.value * weighting;
        }
      });
    });
    securitiesAverage[securityId] = averagePrice;
  });
  return securitiesAverage;
};

export default calculateAveragePricePerSecurity;
